"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _constants = require("../constants");
var styleOverrides = {
    root: function(param) {
        var ownerState = param.ownerState;
        return _object_spread({
            height: 8,
            borderRadius: 4,
            backgroundColor: _constants.colors.oriGrey.A100
        }, ownerState.color === 'inherit' && {
            '&::before': {
                backgroundColor: _constants.colors.oriGrey.A100
            }
        });
    },
    bar: {
        borderRadius: 4
    },
    dashed: {
        backgroundSize: '10.8px 10.8px'
    },
    bar2Buffer: {
        opacity: 0.3
    },
    barColorPrimary: {
        backgroundColor: _constants.colors.error.main
    },
    dashedColorPrimary: {
        backgroundImage: "radial-gradient(".concat(_constants.colors.error.main, " 0%, ").concat(_constants.colors.error.main, " 16%, transparent 42%)")
    },
    barColorSecondary: {
        backgroundColor: _constants.colors.success.main
    },
    dashedColorSecondary: {
        backgroundImage: "radial-gradient(".concat(_constants.colors.success.main, " 0%, ").concat(_constants.colors.success.main, " 16%, transparent 42%)")
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiLinearProgress.js.map
